var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.747 -0.000244141H6.254C2.41 -0.000244141 2.1874e-06 2.39276 2.1874e-06 6.25276V8.57476C-0.000997813 8.99676 0.341002 9.33976 0.763002 9.33976H0.765002H0.774002C1.191 9.33976 1.53 9.00176 1.53 8.58376V8.56576V6.25276C1.53 3.20976 3.21 1.52976 6.253 1.52976H13.747C16.8 1.52976 18.47 3.20976 18.47 6.25276V13.7528C18.47 16.7958 16.79 18.4668 13.747 18.4668H6.254C3.202 18.4668 1.531 16.7868 1.531 13.7528C1.531 13.3308 1.188 12.9878 0.766002 12.9878C0.343002 12.9878 0.00100219 13.3308 0.00100219 13.7528C2.18733e-06 17.6078 2.392 19.9998 6.244 19.9998H13.747C17.608 19.9998 20 17.6078 20 13.7558V6.25576C20 2.39276 17.608 -0.000244141 13.747 -0.000244141ZM9.9945 14.5457C9.5805 14.5457 9.2445 14.2097 9.2445 13.7957V9.37566C9.2445 8.96166 9.5805 8.62566 9.9945 8.62566C10.4085 8.62566 10.7445 8.96166 10.7445 9.37566V13.7957C10.7445 14.2097 10.4085 14.5457 9.9945 14.5457ZM9.9948 6.95386H10.0048C10.4188 6.95386 10.7548 6.61786 10.7548 6.20386C10.7548 5.78986 10.4188 5.45386 10.0048 5.45386C9.5908 5.45386 9.2498 5.78986 9.2498 6.20386C9.2498 6.61786 9.5808 6.95386 9.9948 6.95386Z",
    fill: "#25262D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/Info.c58245a7716a0f41336b7310b8c75d37.svg";
export { ForwardRef as ReactComponent };